import { getCookie } from "cookies-next";
import { axiosInstance } from "../rest/axios";
import { DbBusinessSubscription, DbBusinessSubscriptionType } from "./models";
import {
  doc,
  Firestore,
  getFirestore,
  Timestamp,
  updateDoc,
} from "firebase/firestore/lite";
import { firebaseApp } from "../firebase/client-app";
import { config } from "../config";

export class BusinessSubscriptionService {
  private firebaseDb = getFirestore(firebaseApp, config.DB_NAME);

  private businessSubscriptionRef(firestore: Firestore, businessId: string) {
    return doc(firestore, "businesses", businessId);
  }

  async createSubscription(
    businessId: string,
    paymentId: string,
    subscriptionType: DbBusinessSubscriptionType,
  ): Promise<DbBusinessSubscription> {
    try {
      const res = await axiosInstance.post(
        "business/subscription",
        {
          business_id: businessId,
          payment_id: paymentId,
          subscription_type: subscriptionType,
        },
        { headers: { Authorization: getCookie("Authorization")?.toString() } },
      );

      const subscription: DbBusinessSubscription = {
        type: res.data.type,
        payment_id: res.data.payment_id,
        amount: res.data.amount,
        created_at: res.data.created_at,
        updated_at: res.data.updated_at,
        expiry_date: Timestamp.fromMillis(res.data.expiry_date._seconds * 1000),
      };

      return subscription;
    } catch (error) {
      throw new Error("Subscription creation failed. Please try again.");
    }
  }

  async updateSubscriptionType(
    businessId: string,
    subscriptionType: DbBusinessSubscriptionType,
  ): Promise<void> {
    try {
      const businessDocRef = this.businessSubscriptionRef(
        this.firebaseDb,
        businessId,
      );

      await updateDoc(businessDocRef, {
        "subscription.type": subscriptionType,
        "subscription.updated_at": Timestamp.now(),
      });
    } catch (error) {
      throw new Error("Subscription update failed. Please try again.");
    }
  }
}

export const businessSubscriptionService = new BusinessSubscriptionService();
